<template>
  <button class="btn btn-success" type="button" disabled>
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    {{wording[0].buttons.processing}}
  </button>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: "ProcessingButton",
    computed: {
      ...mapState([
        'wording'
      ]),
    },
  }
</script>

<style scoped>

</style>
